<template>
    <a :href="participant.url" class="person">
        <div class="person__media" v-if="participant.image" v-cloak>
            <div class="person__intrinsic-ratio">
                <img
                    class="person__image"
                    :src="imageUrl(participant, {width: 250, height: 250})"
                    width="150"
                    height="150"
                    :alt="participant.image.alt"
                />
            </div>
        </div>

        <div class="person__details {% if participant.person.image == null %}person__details--full{% endif %}">
            <h3 class="person__name">
                <template v-if="reverse">{{ participant.lastName }}, {{ participant.firstName }}</template>
                <template v-else>{{ participant.firstName }} {{ participant.lastName }}</template>
            </h3>

            <p v-if="participant.attributes.custom.role" class="person__role">{{ participant.attributes.custom.role }}</p>
            <p v-if="participant.attributes.custom.position" class="person__position">{{ participant.attributes.custom.position }}</p>
        </div>
    </a>
</template>

<script>
import {inject} from 'vue';

export default {
  name: 'OrchestraItem',
  props: {
    participant: {
      type: Object,
      required: true,
    },
    reverse: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const imageUrl = inject('imageUrl');

    return {
        imageUrl,
    }
  }
}
</script>
